import type { AlertColor } from '@mui/material/Alert';
import { createSlice } from '@reduxjs/toolkit';

interface SnackbarInfo {
  snackbarInfo: { open: boolean; message: string; severity: AlertColor };
  favoritesLimitModal: { open: boolean; maxFavoriteCount: number | null };
}

const initialState: SnackbarInfo = {
  snackbarInfo: {
    open: false,
    message: '',
    severity: 'success',
  },
  favoritesLimitModal: {
    open: false,
    maxFavoriteCount: null,
  },
};

export const snackBarsSlice = createSlice({
  name: 'snackBars',
  initialState,
  reducers: {
    changeSnackbarInfo: (state, action) => {
      state.snackbarInfo = action.payload;
    },
    openFavoritesLimitModal: (state, action) => {
      state.favoritesLimitModal = {
        open: true,
        maxFavoriteCount: action.payload.maxFavoriteCount,
      };
    },
    closeFavoritesLimitModal: (state) => {
      state.favoritesLimitModal = {
        open: false,
        maxFavoriteCount: null,
      };
    },
  },
});

export const {
  reducer: snackBarsReducer,
  actions: {
    changeSnackbarInfo,
    openFavoritesLimitModal,
    closeFavoritesLimitModal,
  },
} = snackBarsSlice;
